'use strict';

(function ( $ ) {

    /**
     * This should be used with the TinyMCE slider component.
     * It sets max and min from range input.
     * It binds the value of the input to the data and time text
     * @param options the data max amount in GB and the number of minutes = max range
     */
    $.fn.makeSlider = function( options ) {

        var settings = $.extend({
            maxDataAmount: '1.25',
            maxTimeAmount: '100'
        }, options);

        var setDataAndTime = function(elem){
            var value = elem.val();
            var data = (settings.maxDataAmount - value/settings.maxTimeAmount*settings.maxDataAmount)
                .toFixed(2) + ' GB';
            var dataElem = elem.closest('.abbo-slider').find('.data-value');
            dataElem.text(data);

            var time = value + ' MIN';
            var timeElem = dataElem.next();
            timeElem.text(time);
        };

        // init
        setDataAndTime($(this));

        $(this).on('input', function(e){
            setDataAndTime($(this));
        });

        $(this).attr('max', settings.maxTimeAmount);
        $(this).attr('min', 0);
        $(this).val(settings.maxTimeAmount/2);
    };

}( jQuery ));
